import Header from "../../components/header";
import FaqQuestions from "../../components/FaqQuestions/FaqQuestions";
import Footer from "../../components/footer";

function Faq() {
    return(
        <>  
        <Header/>
        <FaqQuestions/>
        <Footer/>
        </>
    );
}

export default Faq;